// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".slide-group_hide{opacity:0}.slide-group .v-slide-group__next,.slide-group .v-slide-group__prev{display:none;opacity:0}.slide-group .v-slide-group__content{transition:0s!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
